import { Form } from "antd/es";
import { PureComponent, ReactNode } from "react";
import KuikaSwitch from "../../../../ui-kit/kuika-switch/kuika-switch";
import { ConfigField, ConfigSectionWarning } from "../config-pane-parts";

// Auth cookie attributes (access_token / refresh_token / is_logged_in /
// session_id / csrf_token) for the generated app. Defaults match production
// behavior: cross-site allowed (SameSite=None) and HTTPS-only (Secure=true).
// Relaxing them is intended for development-oriented configurations only.
export class ConfigAuthCookiesInput extends PureComponent {
  render(): ReactNode {
    return (
      <>
        <ConfigField label="Allow Cross-Site (SameSite=None)">
          <Form.Item name={["apiConfig", "cookieAllowCrossSite"]} valuePropName="checked" noStyle>
            <KuikaSwitch dataTestId="appSettingsCookieAllowCrossSiteSwitch" />
          </Form.Item>
        </ConfigField>

        <ConfigField label="Allow HTTP (disable Secure flag)">
          <Form.Item name={["apiConfig", "cookieAllowHttp"]} valuePropName="checked" noStyle>
            <KuikaSwitch dataTestId="appSettingsCookieAllowHttpSwitch" />
          </Form.Item>
        </ConfigField>

        {/* The caveat is about the PAIR, not about either switch, so it sits under both. */}
        <Form.Item
          shouldUpdate={(prev, current) =>
            prev.apiConfig?.cookieAllowCrossSite !== current.apiConfig?.cookieAllowCrossSite ||
            prev.apiConfig?.cookieAllowHttp !== current.apiConfig?.cookieAllowHttp
          }
          noStyle
        >
          {({ getFieldValue }) => {
            const allowCrossSite: boolean = getFieldValue(["apiConfig", "cookieAllowCrossSite"]) ?? true;
            const allowHttp: boolean = getFieldValue(["apiConfig", "cookieAllowHttp"]) ?? false;
            if (!allowHttp || !allowCrossSite) return null;

            return (
              <ConfigSectionWarning dataTestId="appSettingsCookieHttpCrossSiteWarning">
                Browsers reject SameSite=None cookies without the Secure flag. Over plain HTTP the generated app falls
                back to SameSite=Lax, so cross-site requests will not carry the auth cookies.
              </ConfigSectionWarning>
            );
          }}
        </Form.Item>
      </>
    );
  }
}
